import React, { lazy, Suspense } from 'react';

const DirectorySuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_directory-page" */ './main'
		),
);

const LazyDirectory = (): React.ReactElement => (
	<Suspense fallback={null}>
		<DirectorySuspense />
	</Suspense>
);

/**
 * In a new directory page we need to pass full path in order to keep
 * the component updated when doing manipulations with route
 * programmatically.
 */
const DirectoryRoute = (): React.JSX.Element => {
	return <LazyDirectory />;
};

export default DirectoryRoute;
